module.exports = __webpack_public_path__ + "static/img/prev.81548ab6.png";